import { ADD_COLOR_SCHEME } from '../actions/actionTypes'

const tiles = (state = [], action) => {
	switch(action.type){
		case ADD_COLOR_SCHEME:{
			const tileIndex =action.selectedTile;
			let selectedTile = state.slice(tileIndex,tileIndex+1)[0];
			const colorScheme = [...(selectedTile.colorScheme), action.colorScheme];
			selectedTile.colorScheme= colorScheme;
			state.splice( tileIndex, 1, selectedTile );
			return state;
		}
		default:
			return state;
	}
}

export default tiles;


// WEBPACK FOOTER //
// ./src/reducers/tiles.js